import React from 'react';
import { Range as RcRange } from 'rc-slider';

const Range = props => {
    return (
        <div className="slider">
        <RcRange
            min={props.min}
            max={props.max}
            value={props.value}
            onChange={props.onChange}
            step={props.step} />
        </div>
    );
};

export default Range;


// WEBPACK FOOTER //
// ./src/components/Range.js